import docsContent from "./docs-content.json";
import { DocLayout } from "./layouts.js";

export const DocsPage = () => {
  return (
    <DocLayout>
      <div
        className="prose prose-gray mx-auto max-w-4xl px-6 py-12"
        dangerouslySetInnerHTML={{ __html: docsContent.html }}
      />
    </DocLayout>
  );
};
